// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdBlockerBanner_wrapper__QK8uJ","bannerText":"AdBlockerBanner_bannerText___SSoV","posterWrapper":"AdBlockerBanner_posterWrapper__8uZTq"};